import { Flex, Image, theme, Typography } from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const UnsupportedDevice = () => {
  const { t } = useTranslation();
  const {
    token: {
      colorText,
      colorTextSecondary,
      colorBgContainer,
      fontSize,
      fontSizeLG,
    },
  } = theme.useToken();

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{
        width: '100%',
        height: '100vh',
        backgroundColor: colorBgContainer,
      }}>
      <Flex vertical align="center" gap={8}>
        <Image
          src="/images/block.svg"
          alt="mobile block"
          width={100}
          height={80}
          preview={false}
        />
        <Flex vertical align="center" gap={8} style={{ marginTop: 8 }}>
          <Text
            strong
            style={{
              fontSize: fontSizeLG,
              lineHeight: '24px',
              color: colorText,
            }}>
            {t('errorPage.mobileBlock.title')}
          </Text>
          <Flex vertical align="center" gap={0}>
            <Text
              style={{
                fontSize,
                lineHeight: '22px',
                color: colorTextSecondary,
                textAlign: 'center',
              }}>
              {t('errorPage.mobileBlock.description1')}
            </Text>
            <Text
              style={{
                fontSize,
                lineHeight: '22px',
                color: colorTextSecondary,
                textAlign: 'center',
              }}>
              {t('errorPage.mobileBlock.description2')}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default UnsupportedDevice;
